<script lang="ts">
	import { tweened } from 'svelte/motion';
	import { cubicOut } from 'svelte/easing';
	import type { RadarDotData } from '../../stores/radarPositionStore';

	export let x: number;
	export let y: number;
	export let color: string;
	export let dotData: RadarDotData | undefined;
	export let gridSize: number = 300;

	// Size mirrors Walker.svelte — indicator scales with the grid
	$: indicatorSize = Math.max(32, (gridSize / 16) * 1.5);
	$: indicatorIconSize = Math.max(20, (gridSize / 16) * 1.1); // larger without circle
	$: halfSize = indicatorSize / 2;

	// ── Smooth position tweening ─────────────────────────────────────────────
	const tweenedX = tweened(x, { duration: 400, easing: cubicOut });
	const tweenedY = tweened(y, { duration: 400, easing: cubicOut });

	let previousX = x;
	let previousY = y;

	// Minimum 2D pixel distance required to switch to the running icon.
	// Radar sensors produce constant sub-threshold jitter; below this value
	// the dot still moves smoothly but the icon stays as "standing".
	// const MOVEMENT_THRESHOLD = 8; // px — used when running-dot icon is enabled

	// ── Running-dot icon disabled: keep standing icon (see block below) ───────
	// let isRunning = false;
	// let facingLeft = false;
	// let idleTimeout: ReturnType<typeof setTimeout> | null = null;

	// Single combined reactive block — position tween only (running icon off)
	$: {
		const dx = x - previousX;
		const dy = y - previousY;

		if (dx !== 0) tweenedX.set(x);
		if (dy !== 0) tweenedY.set(y);

		/*
		const distance = Math.sqrt(dx * dx + dy * dy);
		if (distance > MOVEMENT_THRESHOLD) {
			if (Math.abs(dx) > 1) facingLeft = dx < 0;
			isRunning = true;
			if (idleTimeout) clearTimeout(idleTimeout);
			idleTimeout = setTimeout(() => {
				isRunning = false;
				idleTimeout = null;
			}, 1500);
		}
		*/

		previousX = x;
		previousY = y;
	}

	$: xPos = $tweenedX - halfSize;
	$: yPos = $tweenedY - halfSize;

	$: isActive = dotData?.isActive !== false;
</script>

<!-- Dot icon — icon-only (no circular background), same as Walker.svelte -->
<span
	class="dot"
	style:left="{xPos}px"
	style:top="{yPos}px"
	style:width="{indicatorSize}px"
	style:height="{indicatorSize}px"
	style:color
	style:opacity={isActive ? 1 : 0.4}
	aria-hidden="true"
>
	<!-- Running icon (fa-person-running) disabled — motion tween still active -->
	<i class="fas fa-person-simple dot-icon" style:font-size="{indicatorIconSize}px" aria-hidden="true"
	></i>
</span>

<style>
	/* Icon-only — no circular background. color is set via inline style:color */
	.dot {
		position: absolute;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: opacity 0.3s ease-out;
		z-index: 10;
		pointer-events: none;
	}

	/*
	.dot.dot-moving {
		z-index: 12;
	}
	.dot.dot-facing-left :global(.dot-icon) {
		transform: scaleX(-1);
	}
	*/

	.dot :global(.dot-icon) {
		line-height: 1;
	}
</style>
